'use client';

import { useRef } from 'react';
import { isFilled } from '@prismicio/client';

import { List, ListItem, Dropdown as OxygenDropdown } from '@preventx/oxygen';

// Services
import { onNavigate } from '@/services/site/navigation/client';

// Components
import { Link } from '@/components/Actions/Link';

type DropdownProps = {
  id: string;
  label: string;
  options: Array<any>;
};

export const Dropdown = ({ id, label, options }: DropdownProps) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const onClick = () => {
    onNavigate();

    ref.current?.hidePopover();
  };

  return (
    <OxygenDropdown
      id={id}
      ref={ref}
      label={label}
      component="div"
      variant="site-head-link"
    >
      <List component="ul" style="stack-nav">
        {options.map(({ id, link }) => {
          if (!isFilled.link(link)) {
            return null;
          }

          return (
            <ListItem key={`navigation-dropdown-visible-${id}`}>
              <Link
                href={link}
                type="link"
                as="default"
                onClick={onClick}
                retainSearchParams
              >
                {link.text}
              </Link>
            </ListItem>
          );
        })}
      </List>
    </OxygenDropdown>
  );
};
